import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom";
import Spinner from "./views/spinner/Spinner";
import "./assets/scss/style.scss";
import { configureStore } from "./redux/Store";
// setup fake backend
import { ConfigureFakeBackend } from "./jwt/_helpers";
import { Provider } from "react-redux";
ConfigureFakeBackend();
const App = lazy(
  () =>
    new Promise((resolve) => {
      setTimeout(() => resolve(import("./app")), 0);
    })
);


ReactDOM.render(
  <Suspense fallback={<Spinner />}>
    <Provider store={configureStore()}>
      <App />
    </Provider>
  </Suspense>,
  document.getElementById("root")
);
